export const HALF_HOUR_WIDTH_MOBILE = 153;
export const HALF_HOUR_WIDTH = 232;
export const CELL_MARGIN = 4;
export const MINUTES_PER_UNIT = 30;
export const MAX_BLOCKS_DAILY = 48;
export const MAX_BLOCKS_WEEKLY = 336;
export const TIMELINE_BUTTON_WIDTH = 70;
export const MARKER_UPDATE_FREQUENCY_MIN = 1;
export const FUTURE_DATE_PRIMETIME = 18;
